export default __webpack_public_path__ + "static/media/winegrape.27ab6b4b.jpg";